import { render, staticRenderFns } from "./WPBlockHint.vue?vue&type=template&id=096d8651"
import script from "./WPBlockHint.vue?vue&type=script&lang=ts"
export * from "./WPBlockHint.vue?vue&type=script&lang=ts"
import style0 from "./WPBlockHint.vue?vue&type=style&index=0&id=096d8651&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports